import { render, staticRenderFns } from "./historychart.vue?vue&type=template&id=4d63f1a1&scoped=true&"
import script from "./historychart.vue?vue&type=script&lang=js&"
export * from "./historychart.vue?vue&type=script&lang=js&"
import style0 from "./historychart.vue?vue&type=style&index=0&id=4d63f1a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d63f1a1",
  null
  
)

export default component.exports